export const GET_FILTERS_DATA = 'GET_FILTERS_DATA'
export const SET_FILTERS_PLACEMENTS_DATA = 'SET_FILTERS_PLACEMENTS_DATA'
export const SET_FILTERS_DATE_RANGE_DATA = 'SET_FILTERS_DATE_RANGE_DATA'
export const SET_FILTERS_ERROR = 'SET_FILTERS_ERROR'
export const SET_FILTERS_PROCESSING = 'SET_FILTERS_PROCESSING'

export function getFiltersData () {
  return {
    type: GET_FILTERS_DATA,
  }
}

export function setFiltersPlacementsData ({ data }) {
  return {
    type: SET_FILTERS_PLACEMENTS_DATA,
    payload: { data },
  }
}

export function setFiltersDateRangeData ({ data }) {
  return {
    type: SET_FILTERS_DATE_RANGE_DATA,
    payload: { data },
  }
}

export function setFiltersError ({ error }) {
  return {
    type: SET_FILTERS_ERROR,
    payload: { error },
  }
}

export function setFiltersProcessing ({ processing = true }) {
  return {
    type: SET_FILTERS_PROCESSING,
    payload: { processing },
  }
}
